// extracted by mini-css-extract-plugin
export default {"button":"EraserButton_button__x1OrF","active":"EraserButton_active__nNaJ5"};